/**
 * A utility function to merge class names with Tailwind CSS classes.
 */

import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export default function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
